import React, { useState, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { BRANDS, CATEGORIES } from '../mock';
import CategoryPills from '../components/CategoryPills';
import BrandCard from '../components/BrandCard';
import { Input } from '../components/ui/input';
import { Search, SlidersHorizontal } from 'lucide-react';

const BrandsPage = () => {
  const { categoryId } = useParams();
  const active = categoryId || 'all';
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    let list = BRANDS;
    if (active !== 'all') list = list.filter(b => b.category === active);
    if (q) list = list.filter(b => b.name.toLowerCase().includes(q.toLowerCase()));
    return list;
  }, [active, q]);

  const category = CATEGORIES.find(c => c.id === active);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <nav className="text-xs text-neutral-500 mb-2">
          <Link to="/" className="hover:text-neutral-900">Home</Link> / <Link to="/browse" className="hover:text-neutral-900">Browse</Link>
          {active !== 'all' && <> / <span className="text-neutral-900 capitalize">{category?.name}</span></>}
        </nav>
        <h1 className="font-display text-3xl md:text-4xl font-bold">
          {active === 'all' ? 'All brands' : category?.name}
        </h1>
        <p className="text-sm text-neutral-600 mt-1">{filtered.length} brands available · paid with crypto</p>
      </div>

      <div className="mb-6"><CategoryPills categories={CATEGORIES} active={active} /></div>

      <div className="flex flex-col md:flex-row md:items-center gap-3 mb-6">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search within results..."
            className="pl-10 h-11 bg-white border-neutral-200" />
        </div>
        <button className="h-11 px-4 rounded-md border border-neutral-200 bg-white text-sm font-medium flex items-center gap-2 hover:border-neutral-900">
          <SlidersHorizontal className="w-4 h-4" /> Filters
        </button>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-20 text-neutral-500">No brands match your search.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {filtered.map(b => <BrandCard key={b.id} brand={b} />)}
        </div>
      )}
    </div>
  );
};

export default BrandsPage;
